"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_COUNTRY = exports.DEFAULT_LANG = void 0;
// 默认语言
exports.DEFAULT_LANG = {
    code: 1491988,
    name: 'en',
};
// 默认国家
exports.DEFAULT_COUNTRY = {
    code: 153560,
    name: 'us',
};
